import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateAccountWebhookMutation,
  UpdateWebhookInput,
} from '@/gql/graphql';

const UPDATE_ACCOUNT_WEBHOOK_MUTATION = graphql(`
  mutation UpdateAccountWebhook($input: UpdateWebhookInput!) {
    updateWebhook(input: $input) {
      id
    }
  }
`);

const useUpdateAccountWebhook = (
  options?: UseMutationOptions<
    UpdateAccountWebhookMutation,
    unknown,
    UpdateWebhookInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_ACCOUNT_WEBHOOK_MUTATION, { input });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountWebhooks(),
      });
    },
    ...options,
  });
};

export default useUpdateAccountWebhook;
